import api from "../api";

export const getAppointments = async (payload) => {
  const response = await api.post("/PMSRoutes/Appointments", payload);
  return response.data;
};

export const saveConsultation = async (payload) => {
  const response = await api.post("/PMSRoutes/SaveConsultation", payload);
  return response.data;
};

